import axios from "axios";
import i18n from "./i18n";
import bilAPI from "../services/api";
import examAPI from "../services/examAPI";
import externalAPI from "../services/External/externalAPI";

// Keeps the Accept-Language header of every HTTP client (including plain axios calls such as
// login) in step with the UI language, also after the user switches it.
const clients = [axios, bilAPI, examAPI, externalAPI];

const applyLanguage = (lng) => {
  clients.forEach((client) => {
    client.defaults.headers["Accept-Language"] = lng;
  });
};

applyLanguage(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", applyLanguage);
